import React from 'react';
import { Brain, MessageCircle, ShieldCheck } from 'lucide-react';
export function SolutionSection() {
  const phases = [{
    number: '01',
    icon: <Brain className="w-6 h-6 text-warm-accent" data-id="element-129" />,
    title: 'Conexión Silenciosa',
    description: '30 segundos para bajar defensas'
  }, {
    number: '02',
    icon: <MessageCircle className="w-6 h-6 text-warm-accent" data-id="element-130" />,
    title: 'El Despertar del Córtex',
    description: 'La frase de oro neuro-lingüística'
  }, {
    number: '03',
    icon: <ShieldCheck className="w-6 h-6 text-warm-accent" data-id="element-131" />,
    title: 'La Rampa de Salida',
    description: 'El cierre sin conflicto'
  }];
  return <section className="py-10 px-4 bg-white text-deep-blue" data-id="element-132">
      <div className="max-w-6xl mx-auto" data-id="element-133">
        <div className="text-center mb-6" data-id="element-134">
          <h2 className="text-warm-accent text-sm font-bold tracking-widest uppercase mb-4" data-id="element-135">
            El Mecanismo Único
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-136">
            Presentamos el Protocolo Cero Gritos
          </h3>
          <p className="text-xl text-deep-blue/70 max-w-3xl mx-auto" data-id="element-137">
            No es un curso eterno. No es psicología compleja. Es un Manual
            Maestro de Neuro-Regulación diseñado para ser leído en 15 minutos y
            aplicado esta misma tarde.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-138">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gray-200 z-0" data-id="element-139" />

          {phases.map((phase, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-140">
              <div className="w-24 h-24 bg-white rounded-full border-4 border-cream flex items-center justify-center mb-6 shadow-lg" data-id="element-141">
                <span className="text-2xl font-bold text-deep-blue" data-id="element-142">
                  {phase.number}
                </span>
              </div>
              <div className="bg-cream p-8 rounded-3xl w-full h-full border border-gray-100 shadow-sm" data-id="element-143">
                <div className="flex justify-center mb-4" data-id="element-144">{phase.icon}</div>
                <h4 className="text-2xl font-bold mb-3" data-id="element-145">{phase.title}</h4>
                <p className="text-deep-blue/70 text-lg font-medium" data-id="element-146">
                  {phase.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}